/** Legacy demo / mock identities — must not appear in production chats. */

export const LEGACY_MOCK_USER_IDS = new Set([
  'user-1',
  'friend-1',
  'friend-2',
  'guest',
  'op-1',
  'op-2',
  'op-3',
  'op-4',
  'op-5',
  'op-6',
  'op-7',
  'op-8',
]);

export const GUEST_USER_ID = 'guest';

/** Arena messages anonymized after account deletion (server-written). */
export const DELETED_CHAT_USER_ID = 'deleted';

export const LEGACY_MOCK_BET_IDS = new Set(['bet-1', 'bet-agree-1']);

/** Firebase Auth UIDs are long alphanumeric strings (typically 28 chars). */
export function isRealFirebaseUid(userId) {
  return typeof userId === 'string' && /^[A-Za-z0-9]{20,}$/.test(userId);
}

export function isLegacyMockUserId(userId) {
  if (!userId || typeof userId !== 'string') return true;
  return LEGACY_MOCK_USER_IDS.has(userId);
}

/** Valid arena/private sender — real Firebase user only. */
export function isAllowedChatSender(userId) {
  return isRealFirebaseUid(userId);
}

/** Permanent accounts only — guests, mocks, and deleted users cannot receive friend requests. */
export function canReceiveFriendRequest(userId) {
  return isRealFirebaseUid(userId);
}

/** Hide legacy anonymized/deleted senders and demo bots from chat UI. */
export function shouldHideChatSender(userId) {
  if (userId === DELETED_CHAT_USER_ID) return true;
  return isLegacyMockUserId(userId) || !isRealFirebaseUid(userId);
}

export function purgeLegacyChatLocalStorage() {
  try {
    window.localStorage.removeItem('lockedin_private_chat');
    window.localStorage.removeItem('lockedin_arena_chat');
    LEGACY_MOCK_USER_IDS.forEach((uid) => {
      window.localStorage.removeItem(`lockedin_demo_arena_chat_sent_${uid}`);
    });
    window.localStorage.removeItem('lockedin_demo_arena_chat_sent_guest');
  } catch (_) {}
}
